import React from 'react'

import { Modal } from 'react-bootstrap'

import { formatMoney } from 'helpers/helpers';
import { useTranslation } from 'react-i18next';

function BoxDetail({ modal, setModal, data }) {
    const { t } = useTranslation();

    if (!data) return null;

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)} dialogClassName="second">
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('product_details')}
                </div>
                <div className="modal-subtitle mb-32">
                    {data.product_name} ({data.product_code})
                </div>

                <div className="d-flex flex-column gap-2 mb-4 col-6">
                    <div className="d-between">
                        <div className="text-second">{t('category')}</div>
                        <div>{data.product_category_name}</div>
                    </div>

                    <div className="d-between">
                        <div className="text-second">{t('variant')}</div>
                        <div>{data.variant_name}</div>
                    </div>

                    <div className="d-between">
                        <div className="text-second">{t('variant_weight')}</div>
                        <div>{data.variant_weight}</div>
                    </div>

                    <div className="d-between">
                        <div className="text-secondary">{t('box_type')}</div>
                        <div className="fw-bold">{t(data.box_type)}</div>
                    </div>

                    {data.box_type === 'piece' &&
                        <>
                            {/* <div className="d-between">
                                <div className="text-secondary">{t('box_structure')}</div>
                                <div>
                                    {data.rows_per_box} x {data.pieces_per_row} ({t('rows_x_pieces')})
                                </div>
                            </div> */}

                            <div className="d-between">
                                <div className="text-secondary">{t('quantity_per_box')}</div>
                                <div>{formatMoney(data.quantity_per_box)}</div>
                            </div>
                        </>
                    }

                    {data.box_type === 'kg' &&
                        <>
                            <div className="d-between">
                                <div className="text-secondary">{t('amount_kg')}</div>
                                <div>{formatMoney(data.amount_kg)}</div>
                            </div>
                        </>
                    }

                </div>

                {data?.components?.length > 0 &&
                    <>
                        <hr />

                        <div className="fw-bold mb-2">{t('components')}</div>
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '80%' }}>{t('raw_material')}</th>
                                        <th style={{ width: '20%' }}>{t('quantity')}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.components?.map((component) => (
                                        <tr key={component.id}>
                                            <td>{component.raw_material_name}</td>
                                            <td>{formatMoney(component.quantity)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                }

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('close')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default BoxDetail